import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LOADING, NONE } from '../../models/request-status';
class ConfirmModal extends Component {
  static displayName = 'ConfirmModal';

  static propTypes = {
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    description: PropTypes.string,
    title: PropTypes.string,
    buttonName: PropTypes.string
  };

  static defaultProps = {
    onClose: () => {},
    buttonName: 'Change'
  };

  render() {
    let { title, onConfirm, onClose, description, buttonName, isLoading } = this.props;
    var titleComponent = null;
    if (title) {
      titleComponent = <div className="confirmation-title">{this.props.title}</div>;
    }

    return (
      <div className="confirmation-modal">
        {titleComponent}
        <div className="confirmation-description">{description}</div>
        <div className="button-container">
          <span className="modal-button confirm" onClick={onConfirm}>
            {isLoading === LOADING ? <span className="spinner" /> : buttonName}
          </span>
          <div className="modal-button" onClick={onClose} disabled={isLoading === LOADING}>
            Cancel
          </div>
        </div>
      </div>
    );
  }
}

export default ConfirmModal;
